import type { EdrModuleId } from 'src/mindtime/constants/edrSubscriptionModules';
import { getAutomatedResponsePreviewState } from './automatedResponse';
import { getClientsPreviewState } from './clients';
import { getCompliancePreviewState, getComplianceDetailPreview } from './compliance';
import {
  getResellerDashboardPreviewState,
  getSubOrgDashboardPreviewState,
} from './dashboards';
import {
  getEndpointsPreviewState,
  getEndpointPreviewRow,
  getPreviewClientFilterOptions,
  getPreviewEndpointFilterOptions,
} from './endpoints';
import { getFileIntegrityPreviewState, getFileIntegrityDetailPreview } from './fileIntegrity';
import { getMalwarePreviewState, getMalwareDetailPreview } from './malware';
import { getMitrePreviewState, getMitreDetailPreview } from './mitre';
import { getThreatHuntingPreviewState, getThreatHuntingDetailPreview } from './threatHunting';
import { getVulnerabilitiesPreviewState, getVulnerabilityDetailPreview } from './vulnerabilities';

export const getEdrModulePreviewState = (moduleId: EdrModuleId): unknown => {
  switch (moduleId) {
    case 'reseller-dashboard':
      return getResellerDashboardPreviewState();
    case 'sub-org-dashboard':
      return getSubOrgDashboardPreviewState();
    case 'clients':
      return getClientsPreviewState();
    case 'endpoints':
      return getEndpointsPreviewState();
    case 'configuration-compliance':
      return getCompliancePreviewState();
    case 'malware-detection':
      return getMalwarePreviewState();
    case 'automated-response':
      return getAutomatedResponsePreviewState();
    case 'file-integrity-monitoring':
      return getFileIntegrityPreviewState();
    case 'threat-hunting':
      return getThreatHuntingPreviewState();
    case 'vulnerability-detection':
      return getVulnerabilitiesPreviewState();
    case 'mitre-attck':
      return getMitrePreviewState();
    default:
      return null;
  }
};

export {
  getAutomatedResponsePreviewRows,
  getAutomatedResponsePreviewState,
  getAutomatedResponseDetailPreview,
  AUTOMATED_RESPONSE_PREVIEW_ROWS,
} from './automatedResponse';
export type {
  AutomatedActionKey,
  AutomatedResponsePreviewRow,
  AutomatedResponseStatus,
} from './automatedResponse';
export { getClientsPreviewState } from './clients';
export { getComplianceDetailPreview, getCompliancePreviewState } from './compliance';
export {
  getResellerDashboardPreviewState,
  getSubOrgDashboardPreviewState,
} from './dashboards';
export {
  ENDPOINT_EVENTS_PREVIEW_KPIS,
  ENDPOINT_EVENTS_PREVIEW_ROWS,
  ENDPOINT_EVENTS_PREVIEW_SEVERITY,
  getEndpointPreviewRow,
  getEndpointsPreviewState,
  getPreviewClientFilterOptions,
  getPreviewEndpointFilterOptions,
  PREVIEW_ENDPOINT_IDS,
} from './endpoints';
export { getFileIntegrityDetailPreview, getFileIntegrityPreviewState } from './fileIntegrity';
export { getMalwareDetailPreview, getMalwarePreviewState, PREVIEW_MALWARE_IDS } from './malware';
export { getMitreDetailPreview, getMitrePreviewState, PREVIEW_MITRE_IDS } from './mitre';
export { previewPaged } from './previewUtils';
export {
  getThreatHuntingDetailPreview,
  getThreatHuntingPreviewState,
  THREAT_HUNTING_KPI,
  THREAT_HUNTING_RESULT_ROWS,
} from './threatHunting';
export type { ThreatHuntingPieData, ThreatHuntingResultRow, ThreatHuntingStat } from './threatHunting';
export {
  getVulnerabilityDetailPreview,
  getVulnerabilitiesPreviewState,
  PREVIEW_VULN_IDS,
} from './vulnerabilities';
